import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useComps } from '.'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const comps = useComps()

const mounted = (comp: any, name: any) => {
  console.log(`${name} mounted`)
  // 此时存在ref值
}

const unmounted = (comp: any, name: any) => {
  console.log(`${name} unmounted`)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(comps), (v, k) => {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
      (v.visible)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(v.comp), _mergeProps({
            key: 0,
            key: v.key,
            ref: (c) => (v.ref = c),
            "onVue:mounted": ($event: any) => (mounted(v, k)),
            "onVue:unmounted": ($event: any) => (unmounted(v, k))
          }, v.props, {
            onUnmounted: ($event: any) => (v.visible = false)
          }), null, 16, ["onVue:mounted", "onVue:unmounted", "onUnmounted"]))
        : _createCommentVNode("", true)
    ], 64))
  }), 256))
}
}

})